export class DisposalPlacesSettings {
    public city: string;
}